export const API_BASE_URL = "";
export const TILE_URL = process.env.REACT_APP_TILE_URL || "/tiles/styles/default/{z}/{x}/{y}.png";
